(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-photo-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function goTo(root, index) {
      var track = root.querySelector('[data-ppg-track]');
      var total = track.children.length;
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
    }

    function currentIndex(track) {
      return Math.round(track.scrollLeft / track.clientWidth) || 0;
    }

    document.addEventListener('click', function (e) {
      var root = e.target.closest('[data-ppg]');
      if (!root) return;
      var track = root.querySelector('[data-ppg-track]');

      if (e.target.closest('[data-ppg-next]')) { goTo(root, currentIndex(track) + 1); return; }
      if (e.target.closest('[data-ppg-prev]')) { goTo(root, currentIndex(track) - 1); return; }

      var thumb = e.target.closest('[data-ppg-thumb]');
      if (thumb) { goTo(root, parseInt(thumb.getAttribute('data-ppg-thumb'), 10)); }
    });

    document.addEventListener('keydown', function (e) {
      var track = e.target.closest && e.target.closest('[data-ppg-track]');
      if (!track) return;
      var root = track.closest('[data-ppg]');
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(root, currentIndex(track) + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(root, currentIndex(track) - 1); }
    });

    var ticking = false;
    document.addEventListener('scroll', function (e) {
      var track = e.target;
      if (!track.hasAttribute || !track.hasAttribute('data-ppg-track') || ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var root = track.closest('[data-ppg]');
        var index = currentIndex(track);
        var count = root.querySelector('[data-ppg-count]');
        if (count) count.textContent = (index + 1) + ' / ' + track.children.length;

        var thumbs = root.querySelector('[data-ppg-thumbs]');
        if (!thumbs) return;
        var buttons = thumbs.querySelectorAll('.ppg-thumb');
        for (var i = 0; i < buttons.length; i++) {
          buttons[i].classList.toggle('is-active', i === index);
        }
        var active = buttons[index];
        if (active) {
          thumbs.scrollTo({
            left: active.offsetLeft - thumbs.clientWidth / 2 + active.clientWidth / 2,
            behavior: 'smooth'
          });
        }
      });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
